import { render, staticRenderFns } from "./main.subcategoria.vue?vue&type=template&id=208a511e"
import script from "./main.subcategoria.vue?vue&type=script&lang=js"
export * from "./main.subcategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports